import PopoverMixin from './popoverMixins.js'
  export default {
    mixins: [PopoverMixin]
  }


/** WEBPACK FOOTER **
 ** ./src/Popover.vue
 **/